M.Checkout = M.Checkout || {};

$('.upsell-product-container').each(function(){
  const $carousel = $(this),
    $carouselAddButton = $carousel.find('.upsell-product-btn'),
    $carouselRemoveButton = $carousel.find('.upsell-product-btn-clear'),
    removeOrderLineHandler = function(event) {
      var $parentElement = $(event.target).parent();
      var $addedMessage = $parentElement.find('.upsell-product-image-message');
      var $addButton = $parentElement.find('.upsell-product-btn');
      var $removeButton = $parentElement.find('.upsell-product-btn-clear');
      var $loaderButton = $parentElement.find('#upsell-product-btn-loading-spinner-clear');
      $loaderButton.attr('class', 'upsell-product-btn-loading-spinner upsell-product-btn-loading-spinner-clear');
      $removeButton.addClass('upsell-product-btn--hidden');
      $.ajax({
        type: 'POST',
        url: '/order/line/delete',
        data: {
          order_line_item_id:event.target.getAttribute('data-value')
        },
        success: function(response) {
          $addedMessage.addClass('upsell-product-image--not-added');
          $addedMessage.removeClass('upsell-product-image--added');
          $addButton.removeClass('upsell-product-btn--hidden');
          $loaderButton.attr('class', 'upsell-product-btn-loading-spinner upsell-product-btn--hidden');
        },
        error: function(error) {
          $removeButton.removeClass('upsell-product-btn--hidden');
          $loaderButton.attr('class', 'upsell-product-btn-loading-spinner upsell-product-btn-loading-spinner-clear upsell-product-btn--hidden');
          alert('Sorry, there was an error trying to remove this item.');
          console.log('Failed: ', error);
         }
      })
    },
    addToCartHandler = function(event) {
      var $parentElement = $(event.target).parent().parent();
      var $addedMessage = $parentElement.find('.upsell-product-image-message');
      var $addButton = $parentElement.find('.upsell-product-btn');
      var $removeButton = $parentElement.find('.upsell-product-btn-clear');
      var $loaderButton = $parentElement.find('#upsell-product-btn-loading-spinner');
      var $buttonMessage = $parentElement.find('.upsell-product-btn-message');
      $addButton.addClass('upsell-product-btn--loader');
      $loaderButton.attr('class', 'upsell-product-btn-loading-spinner');
      $buttonMessage.addClass('upsell-product-btn--hidden');
      $.ajax({
        url: '/personalize/add-to-cart/' + event.target.getAttribute('data-value'),
        type: 'post',
        data: {
          q: 1,
          type: 'json'
        },
        success: function(response) {
          $addedMessage.removeClass('upsell-product-image--not-added');
          $addedMessage.addClass('upsell-product-image--added');
          $addButton.removeClass('upsell-product-btn--loader');
          $addButton.addClass('upsell-product-btn--hidden');
          $loaderButton.attr('class', 'upsell-product-btn-loading-spinner upsell-product-btn--hidden');
          $buttonMessage.removeClass('upsell-product-btn--hidden');
          $removeButton.removeClass('upsell-product-btn--hidden');
          $removeButton.attr('data-value', response.id);
          window.location.reload();
        },
        error: function(error) {
          $loaderButton.attr('class', 'upsell-product-btn-loading-spinner upsell-product-btn--hidden');
          $buttonMessage.removeClass('upsell-product-btn--hidden');
          $addButton.removeClass('upsell-product-btn--loader');
          alert('Sorry, there was an error trying to add this item.');
          console.log('Failed: ', error);
        }
      });
    };

  $carouselAddButton.on('click', addToCartHandler);
  $carouselRemoveButton.on('click', removeOrderLineHandler);
});
